import { SupplierGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createEmitter, createListController } from "../utils";
import { Supplier } from "./interfaces";

export const makeSupplier = ({ connection, company }: ApiSliceParams) => {
    const { emit, on, off } = createEmitter<Supplier>();
    const {
        items: suppliers,
        allLoading: loading,
        allLoaded: loaded,
        get,
        listen,
    } = createListController<SupplierGet, Supplier>({
        name: "supplier",
        connection,
        list: (con) => con.supplier.items({ company: company.value }),
        emit,
    });

    return {
        suppliers,
        loading,
        loaded,
        on,
        off,
        listen,
        get,
    };
};
